module.exports = __webpack_public_path__ + "static/001_Gippsland-356e70ee4129c27ffa4152a2234b221d.png";